import React from "react";
import "./common.scss";
import { ReactComponent as CheckedRadio } from "../../Assets/Icons/checkedRadio.svg";
import { ReactComponent as UncheckedRadio } from "../../Assets/Icons/uncheckedRadio.svg";

const RadioButton = ({
  divClassName,
  text,
  checked,
  onChecked,
  textClass,
  content,
  contentClass,
}) => {
  return (
    <div className={divClassName}>
      {checked ? (
        <CheckedRadio onClick={onChecked} className="radio" />
      ) : (
        <UncheckedRadio onClick={onChecked} className="radio" />
      )}
      {content ? (
        <div className="flex flex-col justify-start items-start gap-2">
          <label className={`cursor-pointer ${textClass}`} onClick={onChecked}>
            {text}
          </label>
          <p className={`${contentClass} align-left`}>{content}</p>
        </div>
      ) : (
        <label className={`cursor-pointer ${textClass}`} onClick={onChecked}>
          {text}
        </label>
      )}
    </div>
  );
};

export default RadioButton;
